import { createFileRoute } from "@tanstack/react-router";
import { getGuide } from "@/data/guides";
import { GuidePage } from "@/components/site/GuidePage";
import { meta } from "@/lib/schema";
import { overviewKeywords } from "@/lib/localKeywords";

const guide = getGuide("spoedverhuizing")!;

export const Route = createFileRoute("/spoedverhuizing")({
  head: () =>
    meta({
      title: guide.seoTitle,
      description: guide.seoDescription,
      path: "/spoedverhuizing",
      image: guide.image,
      keywords: overviewKeywords(guide.keywords),
    }),
  component: () => <GuidePage guide={guide} />,
});
